<template>
  <div class="q-edit-content">
    <table class="matrix-table"
           :class="{isShow:!value.ext.edit}">
      <tr v-if="value.ext.edit">
        <td style="width:30px;height:28px;"></td>
        <td></td>
      </tr>
      <tr>
        <td v-if="value.ext.edit"
            style="height:35px;"></td>
        <td></td>
      </tr>
      <tr v-for="(item,index) in value.detail.row"
          :key="index">
        <td v-if="value.ext.edit"><span @click="delRowItem(index)"
                class="remove">删</span></td>
        <td>
          <com-input v-if="value.ext.edit"
                     @focus="itemFocus(item)"
                     :class="{error:item.error}"
                     v-model="item.value"
                     :max-length="5"></com-input>
          <span v-if="!value.ext.edit"
                v-text="item.value"></span>
        </td>
      </tr>
    </table>
    <div class="main-table"
         ref="tb">
      <table class="matrix-table"
             :style="{left:`${left}px`}"
             :class="{isShow:!value.ext.edit}">
        <tr v-if="value.ext.edit">
          <td v-for="(item,index) in value.detail.column"
              :key="index">
            <span @click="delColumnItem(index)"
                  class="remove">删</span>
          </td>
        </tr>
        <tr>
          <td v-for="(item,index) in value.detail.column"
              :key="index">
            <com-input v-if="value.ext.edit"
                       @focus="itemFocus(item)"
                       :class="{error:item.error}"
                       v-model="item.value"
                       :max-length="5"></com-input>
            <span v-if="!value.ext.edit"
                  v-text="item.value"></span>
          </td>
        </tr>
        <tr v-for="(itemRow,indexRow) in value.detail.row"
            :key="indexRow">
          <td v-for="(itemCol,indexCol) in value.detail.column"
              :key="indexCol">
            <vh-radio v-if="value.detail.format==='radio'"
                      v-model="itemRow.selected"
                      :label="`${indexRow+1}-${indexCol+1}`"></vh-radio>
            <vh-checkbox v-if="value.detail.format==='checkbox'"
                         v-model="itemRow.selected"
                         :label="`${indexRow+1}-${indexCol+1}`"></vh-checkbox>
          </td>
        </tr>
      </table>
    </div>
    <div v-if="!value.ext.edit&&errorTip"
         class="error-msg">{{errorTip}}
    </div>
  </div>
</template>

<script>

import ComInput from '../input/com.vue'

export default {
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  componets: {
    'com-input': ComInput
  },

  data () {
    return {
      left: -1,
      errorTip: ''
    }
  },
  methods: {
    focus () {
      this.errorTip = ''
    },
    itemFocus (item) {
      if (item.error) {
        item.error = false
        item.value = ''
      }
    },
    delRowItem (index) {
      this.value.detail.row.splice(index, 1)
    },
    delColumnItem (index) {
      this.value.detail.column.splice(index, 1)
    },
    check () {
      let val = ''
       let _arr = []
        if (this.value.detail.format === 'radio') {
          this.value.detail.row.forEach((item) => {
           item.selected&&_arr.push(item.selected)
          })
        }
        else if (this.value.detail.format === 'checkbox') {
          this.value.detail.row.forEach((item) => {
            _arr = _arr.concat(item.selected)
          })
        }
      if (this.value.required==='Y' ) {
        if (_arr.length === 0) {
          this.errorTip =this.$t('form.form_1083')
          return false
        }
      }
      console.log(_arr)
      val = _arr.join(',')
      return { id: this.value.id, value: val }
    }
  }
}
</script>

<style scoped lang="scss">
.q-edit-content {
  overflow: hidden;
  ::v-deep {
    * {
      font-size: 12px;
    }
    .main-table {
      overflow: auto;
      // border-right: 1px solid #dadada;
      .matrix-table {
        position: relative;
        // border-right: 0;
      }
    }
    .matrix-table {
      border-right: 1px solid #dadada;
      border-bottom: 1px solid #dadada;
      border-collapse: collapse;
      border-spacing: 0;
      float: left;
      &.isShow {
        td {
          height: 35px;
          padding: 0 10px;
          white-space: nowrap;
        }
      }
      td {
        padding: 0 5px;
        height: 35px;
        text-align: center;
        border-left: 1px solid #dadada;
        border-top: 1px solid #dadada;
      }
      .remove {
        cursor: pointer;
      }
      .com-input {
        height: 24px;
        width: 100px;
      }
      .vh-radio,
      .vh-checkbox {
        padding: 4px 0;
        .vh-checkbox__original {
          display: none;
        }
      }
      .vh-radio__label,
      .vh-checkbox__label {
        display: none;
      }
    }
    .error-msg {
      position: absolute;
      color: #fc5659;
      padding-left: 10px;
      line-height: 20px;
      font-size: 12px;
    }
  }
}
</style>
